import React, {
  FunctionComponent,
  ReactElement,
  ReactNode,
  useEffect,
} from 'react';

import {
  usePopoverState,
  PopoverDisclosure,
  PopoverStateReturn,
  PopoverProps,
  PopoverInitialState,
} from 'reakit/Popover';
import { StyledPopover, StyledPopoverArrow } from './styles';

export interface OlPopoverProps {
  toggle: ReactElement;
  content: ReactNode;
  placement?: PopoverStateReturn['placement'];
  popOverInitialState?: PopoverInitialState;
  popOverProps?: PopoverProps;
  withArrow?: boolean;
  onOpen?: () => void;
}

/**
 * This styled Popover built from base popover component from reakit.
 * See more at https://reakit.io/docs/popover/
 */
export const Popover: FunctionComponent<OlPopoverProps> = ({
  toggle,
  content,
  placement = 'auto',
  popOverProps,
  popOverInitialState,
  withArrow = true,
  onOpen,
}) => {
  const popover = usePopoverState({
    placement,
    unstable_fixed: true,
    ...popOverInitialState,
  });

  useEffect(() => {
    if (popover.visible && onOpen) {
      onOpen();
    }
  }, [popover.visible]);

  return (
    <>
      <PopoverDisclosure {...popover} as="span">
        {toggle}
      </PopoverDisclosure>
      <StyledPopover {...popover} {...popOverProps}>
        {withArrow && <StyledPopoverArrow {...popover} size="16px" />}
        {content}
      </StyledPopover>
    </>
  );
};
